import { render, staticRenderFns } from "./Mahasiswa.vue?vue&type=template&id=6373b8d5"
import script from "./Mahasiswa.vue?vue&type=script&lang=js"
export * from "./Mahasiswa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports